@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.modal {
  padding: 0;
  max-width: 626px;
  width: calc(100% - 30px);
}

.content {
  padding: 24px;
}

.title {
  @include t.text(20px, 30px, 600);
  text-align: center;
  color: v.$palette-gray-900;
}

.text {
  @include t.text(14px, 22px, 400);
  text-align: center;
  color: v.$palette-gray-800;
  margin: 24px 0;
}

.icon {
  width: 100px;
  height: 100px;
}